<template>
  <div v-editable="blok" class="menu-item" :class="{ 'is-parent': blok.tabs && blok.tabs.length > 0 }" menu-item>
    <a v-if="blok.link?.cached_url" :href="getLinkFieldUrl(blok.link)" :target="blok.link?.target" class="menu-link" @mouseenter="renderTab = true">{{ blok.label }}</a>
    <div v-else class="menu-link">{{ blok.label }}</div>
    <div v-if="renderTab" class="menu-box">
      <div class="container container--bleed">
        <div v-for="(group, g) in blok.tabs" :key="g" v-editable="group" class="menu-group">
          <MenuGroup v-if="group?.component === 'menu_group'" :blok="group" />
          <MenuArticle v-else-if="group?.component === 'menu_article'" :blok="group" />
          <MenuBanner v-else-if="group?.component === 'menu_banner'" :blok="group" />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
  import type { MenuTab } from "@/types/storyblok";
  import { getLinkFieldUrl } from "#imports";
  defineProps<{ blok: MenuTab }>();

  const renderTab = ref(false);
</script>
